import { Font } from '@react-pdf/renderer';
// import src from './PFDINTextPro-Light.ttf';
// console.log(src);
/** @type {import('@react-pdf/types').SingleLoad} */
const font = {
  family: 'PF DIN Text Pro',
  fontWeight: 300,
  format: 'truetype',
  src: 'https://res.cloudinary.com/bottlebooks/raw/upload/vievinum/PFDinTextPro-Light.ttf',
};

Font.register(font);

const style = { fontFamily: font.family, fontWeight: Number(font.fontWeight) };
export default style;
